<template>
    <div v-loading="loading" class="order-infoTab-section">
        <el-row :gutter="20">
            <el-col :span="4" :offset="20"><el-button type="primary" plain @click="getProduct()" :loading="addLoading">+添加断续原因</el-button></el-col>
        </el-row>
        <el-steps direction="vertical" :space="100">
            <el-step icon="el-icon-fa-user" v-for="(item, index) in list" :key="index">
                <div slot="title" class="title-step">
                    <span class="span-label">联系人：{{ item.contact_name }}</span>
                    <span class="span-label">填写时间：{{ item.created_at }}</span>
                    <span class="span-label">断续产品：{{ item.product_names }}</span>
                </div>
                <div slot="description" class="des-step" style="margin: 10px;padding: 10px;background: #f3f3f3;color: #333;font-size: 14px;">
                    <div>{{ item.memo }}</div>
                </div>
            </el-step>
        </el-steps>
        <el-dialog title="断续原因" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="联系人" prop="contact_id" :label-width="formLabelWidth">
                    <el-select v-model="form.contact_id" placeholder="请选择联系人" size="small">
                        <el-option v-for="contact in contacts" :key="contact.id" :label="contact.name" :value="contact.id" v-show="contact.customer_id==customerId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="断续产品" prop="order_product_ids" :label-width="formLabelWidth">
                    <el-checkbox-group v-model="form.order_product_ids">
                        <div v-for="product in product_list" :key="product.id">
                            <el-checkbox :label="product.id">{{ product.product_name }}（{{ product.start_at }} - {{ product.end_at }}）</el-checkbox>
                        </div>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="断续原因" prop="memo" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.memo"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitDisable">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import CommonService from "~/services/common";
    import OrderDisruptionService from "~/services/OrderDisruption";
    export default {
        name: "Disruption",//断续记录
        data() {
            return {
                list: [],
                contacts: [],
                product_list: [],
                loading: false,
                addLoading: false,
                // 分页信息
                customer_name: "",
                form:{
                    contact_id: '',
                    order_product_ids: [],
                    memo: ''
                },
                dialogFormVisible: false,
                formLabelWidth: '120px',
                submitDisable: false,
                rules: {
                    contact_id: [{required: true, message: "请选择联系人", trigger: "change"}],
                    order_product_ids: [{required: true, message: "请选择断续产品", trigger: "change"}],
                    memo: [{required: true, message: "请选输入原因", trigger: "blur"}],
                },
            }
        },
        components: {
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        created: function () {
            if (this.customerId < 1) {
                this.$message({
                    message: '客户编号异常！',
                    type: 'error'
                });
                return false;
            }
            this.getCustomerLog();
            this.getContacts();
        },
        methods: {
            resetForm(){
                this.form = {
                    contact_id: '',
                    order_product_ids: [],
                    memo: ''
                };
                this.dialogFormVisible = false;
                this.getCustomerLog();
            },

            getCustomerLog() {
                this.loading = true;
                OrderDisruptionService.getCustomerLog(this.customerId).then(res => {
                    if (res && res.data) {
                        this.list = res.data;
                        // 循环遍历数据并添加product_names字段
                        this.list.forEach(item => {
                            // 使用map函数提取product_name字段
                            const productNames = item.products.map(product => product.product_name);
                            // 使用join函数将字段用逗号分隔拼接成字符串
                            item.product_names = productNames.join('、');
                        });
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            },

            getContacts() {
                CommonService.getContacts({customer_id: this.customerId}).then(res => {
                    if (res && res.data) {
                        this.contacts = res.data;
                    }
                }).catch(err => {
                    console.error(err);
                })
            },
            getProduct() {
                this.addLoading = true;
                OrderDisruptionService.getProduct(this.customerId).then(res => {
                    if (res && res.data && res.data.length > 0) {
                        this.product_list = res.data;
                        this.dialogFormVisible = true;
                    }else{
                        this.$message({
                            type: 'error',
                            message: '该客户不存在断续产品，操作失败！'
                        });
                    }
                    this.addLoading = false;
                }).catch(err => {
                    console.error(err);
                    this.addLoading = false;
                })
            },

            submitForm(){
                this.submitDisable = true;
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        let params = this.form;
                        params['customer_id'] = this.customerId;
                        OrderDisruptionService.create(params).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功!'
                                });
                                this.resetForm();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                });
                            }
                            this.submitDisable = false;
                        }).catch(err => {
                            console.error(err);
                            this.submitDisable = false;
                        })
                    } else {
                        this.submitDisable = false;
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>
.span-label{
    margin-left:20px;
}
.el-row {
    padding: 5px;
}
.main-bd .el-row {
    padding: 5px 0;
}
</style>





// WEBPACK FOOTER //
// src/views/customer/Disruption.vue